<template>
    <div class="spelling-course">
        <div class="course-header">
            <div class="course-content">
                <div class="qtz-course"><img src="../../assets/imgs/course/spelling-course-title-icon.png" style="vertical-align: middle" alt=""><span style="display: inline-block;vertical-align: middle">专项能力课-英文专项课</span></div>
                <ul class="course-detail">
                    <li>七田真自然拼读专项课采用主题式、母语浸入式教学方法，</li>
                    <li>让孩子们在五感游戏中掌握26个字母的发音练习基础的拼读技巧。</li>
                </ul>
            </div>
        </div>
        
        <div class="course-content">
            <img src="../../assets/imgs/course/spelling-course-1.png" alt="">
            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">趣味字母学习</button>
                </div>
            </div>
            <img style="margin-top: 40px" src="../../assets/imgs/course/spelling-course-2.png" alt="">

            <div class="content-item" style="margin-top:60px;">
                <div class="content-title">
                    <button class="page-btn">多样拼读教具</button>
                </div>
            </div>
            <img src="../../assets/imgs/course/spelling-course-5.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "spelling-course",
        data(){
            return {

            }
        }
    }
</script>

<style scoped lang="less">
    .spelling-course{
        background: #fff;
        .course-header{
            background-image: url("../../assets/imgs/course/memory-course-bg.png");
        }
        .content-item{
            border-top: 1px solid #F8B300;
        }
        .page-btn{
            background: #F8B300;
        }
        .max-title{
            color: #F8B300;
            border-bottom: 1px solid #F8B300;
        }
        .list-text{
            margin: 30px 0;
            color: #6A6767;
            font-size: 16px;
            font-family: Light;
            li{
                img{
                    margin-right: 15px;
                }
            }
        }
    }
</style>